import { shouldAskConsent, useConsent } from '../lib/consent';
import { Link } from '../lib/router';
import { Button } from './Button';

/**
 * The analytics question, asked only where opt-in is required (EEA, UK, Switzerland). It floats
 * over the page (no layout shift) and stays out of the way during a round.
 */
export function ConsentBanner({ path }: { path: string }) {
  const choice = useConsent((s) => s.choice);
  const choose = useConsent((s) => s.choose);
  if (!shouldAskConsent(choice) || path.startsWith('/play') || path === '/admin') return null;
  return (
    <div
      role="region"
      aria-label="Analytics choice"
      className="animate-fade-up fixed inset-x-3 bottom-3 z-30 mx-auto max-w-lg rounded-2xl bg-ink-3 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl ring-1 ring-white/10"
    >
      <p className="text-sm text-white">
        Can we count your visit with Google Analytics? It sets cookies only if you allow it.{' '}
        <Link to="/privacy" className="text-accent underline underline-offset-2">
          Privacy
        </Link>
      </p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => choose('granted')}>
          Allow
        </Button>
        <Button size="sm" variant="secondary" onClick={() => choose('denied')}>
          No thanks
        </Button>
      </div>
    </div>
  );
}
